import "UI/Widget/Forms/Control/Element";
NS("UI.Widget.Forms.Control");

UI.Widget.Forms.Control.Label = Class(UI.Widget.Forms.Control.Element, {
    createElement: function() {
        this.$element = $("<label>");
    }
});
